import {gsap, Observer} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Header {

	static init() {
		this.header = document.querySelector(".header-main");
		this.toggleHeader();
		// GlobalVariables.resizeCallbacks.push(this);
	}

	static toggleHeader() {
		let mm = gsap.matchMedia();
		mm.add("(min-width: 992px)", () => {
			Observer.create({
				type: "scroll",
				tolerance: 30,
				dragMinimum: 30,
				onStop: () => {
					if (window.scrollY < 100) {
						this.header.classList.remove("is-on-top");
					} else {
						this.header.classList.add("is-on-top");
					}
				},
				onStopDelay: 0,
				onUp: () => {
					// this.showHeader();
				},
				onDown: () => {
					// this.hideHeader();
					this.header.classList.add("is-on-top");
				}
			});

			if (window.innerWidth > 991) {
				setTimeout(() => {
					if (window.scrollY > 100) {
						this.hideHeader();
					}
				}, 0);
			}
		});
	}

	static hideHeader() {
		this.header.classList.add("hide");
	}

	static showHeader() {
		this.header.classList.remove("hide");
	}

}
